import Repository from './Repository';

const resource = '/activities';
export default {
  get(type, year, config) {
    return Repository.get(`${resource}?type=${type}&year=${year}`, config);
  },
  getRoutes() {
    return Repository.get(`${resource}/maps`);
  },
}
